import { Box, Drawer, makeStyles, useMediaQuery, useTheme } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import MenuAppBar from './AppBar'
import Sidebar from './Sidebar'
import AppQrCard from './AppQrCard'
import LogoPromptDialog from './LogoPromptDialog'
import { ContactModal } from '../../pages/Login'
import { logoSrc } from '../../api/logoSrc'
import { GlobalToast } from '../../api/toast'
import { useLocation } from 'react-router-dom'
import { logout } from '../../api/authenticate'
import api from '../../api/client'
import { useSetRecoilState } from 'recoil'
import { loadingState, loggedInState, userInfoState } from '../../recoil/atoms'
import { useRecoilValue } from 'recoil'
import {
  isEnabled as notifEnabled, permissionState as notifPermission,
  requestPermission as requestNotifPermission, showMessageNotification,
} from '../../api/notification'
import { toast } from '../../api/toast'

const useStyles = makeStyles((theme) => ({
  content: {
    flex: 1,
    width: '100%',
    boxSizing: 'border-box',
    padding: '20px 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '14px 10px',
    },
  },
}))

const Layout = (props) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const setLoggedIn = useSetRecoilState(loggedInState)
  const userInfo = useRecoilValue(userInfoState)
  const setLoading = useSetRecoilState(loadingState)
  const setUserInfo = useSetRecoilState(userInfoState)
  const [menuOpen, setMenuOpen] = useState(false)
  const [contactOpen, setContactOpen] = useState(false)
  const [logoPrompt, setLogoPrompt] = useState(false)
  const location = useLocation()

  // پیشنهادِ ثبت لوگو/عکس برای کاربرانی که هنوز تصویری ندارند (یک‌بار در هر نشست)
  useEffect(() => {
    if (!userInfo || !userInfo.id || userInfo.role === 'Admin') return undefined
    if (userInfo.logo) return undefined
    if (sessionStorage.getItem('logoPromptSkipped')) return undefined
    let alive = true
    api.get(logoSrc(`users/logo/${userInfo.id}/`))
      .then(() => { if (alive) sessionStorage.setItem('logoPromptSkipped', '1') })
      .catch((e) => {
        if (alive && e && e.response && e.response.status === 404) {
          setLogoPrompt(true)
        }
      })
    return () => { alive = false }
  }, [userInfo])

  // ── نوتیفِ «پیام جدید» ──
  // نوتیف فقط اطلاع‌رسانی است و متنِ پیام را نشان نمی‌دهد.
  const [notifState, setNotifState] = useState('idle') // idle | granted | denied | unsupported
  const hadNewRef = useRef(false)

  useEffect(() => {
    setNotifState(notifPermission())
  }, [])

  const enableNotifications = async () => {
    const res = await requestNotifPermission()
    setNotifState(res)
    if (res === 'granted') {
      toast('نوتیفِ پیام‌های جدید فعال شد.', 'success')
    } else if (res === 'denied') {
      toast('اجازهٔ نمایشِ نوتیف داده نشد؛ می‌توانید از تنظیماتِ مرورگر آن را باز کنید.', 'error')
    }
  }

  // پینگ حضور — هر ۶۰ ثانیه برای آمار «کاربران آنلاین» + بررسیِ پیامِ جدید
  useEffect(() => {
    const ping = () => api.post('users/online/ping/').catch(() => {})
    const checkNotification = () => api.post('users/online/ping/')
      .then((res) => {
        const n = res?.data?.notification
        if (!n || !n.new_message) { hadNewRef.current = false; return }
        // فقط بارِ اولِ هر پیامِ جدید ⇒ نوتیف داده شود
        if (!hadNewRef.current) {
          hadNewRef.current = true
          showMessageNotification(n.from_name)
          toast('پیام جدیدی دارید.', 'info')
        }
      })
      .catch(() => {})
    ping()
    checkNotification()
    const t = setInterval(() => { ping(); checkNotification() }, 60000)
    return () => clearInterval(t)
  }, [])

  const sidebarProps = {
    logout: () => logout(setLoggedIn, setLoading, setUserInfo),
    editProfile: '/user-management',
    firstTimeLogin: userInfo.first_time_login,
    onSwitchRole: props.onSwitchRole,
    onContact: () => setContactOpen(true),
  }

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        minHeight: '100vh',
        minWidth: 0,
        width: '100%',
        background: '#f4f6fb',
      }}
    >
      {/* سایدبار راست — دسکتاپ */}
      {!isMobile && <Sidebar {...sidebarProps} />}

      <Box style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <MenuAppBar
          title="سامانه ارجان پیمان"
          onOpenMenu={isMobile ? () => setMenuOpen(true) : undefined}
        />
        {/* کیوآرکد لینک سامانه — فقط صفحهٔ اول؛ فضای پایین صفحه رزرو میشود تا چیزی زیرش پنهان نشود */}
        {/* فضای پایین صفحه فقط برای کارتِ کیوآر ادمین رزرو میشود */}
        <Box className={classes.content} style={{ paddingBottom: location.pathname === '/' && userInfo.role === 'Admin' && !isMobile ? 190 : undefined }}>
          {props.children}
        </Box>
      </Box>

      {/* کشوی منو — موبایل */}
      <Drawer anchor="right" open={!!menuOpen && isMobile} onClose={() => setMenuOpen(false)}>
        <Sidebar {...sidebarProps} onClose={() => setMenuOpen(false)} />
      </Drawer>

      {/* کیوآرکد لینک سامانه — فقط صفحهٔ اول؛
          ادمین: کارت بزرگ همیشه‌نمایان | بقیهٔ نقشها: نشانِ کوچک (هاور/کلیک) */}
      {location.pathname === '/' && (
        <AppQrCard variant="mini" />
      )}

      {/* Toast سراسری (جایگزین alert) */}
      <GlobalToast />

      {/* مودال تماس با ما */}
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />

      {/* پیشنهادِ ثبت لوگو/عکس (موبایل: دوربین | کامپیوتر: کیوآرکد) */}
      <LogoPromptDialog
        open={logoPrompt}
        onClose={(done) => {
          if (!done) sessionStorage.setItem('logoPromptSkipped', '1')
          setLogoPrompt(false)
        }}
        userInfo={userInfo}
        onUploaded={(path) => {
          setUserInfo((prev) => ({ ...(prev || {}), logo: path || `users/logo/${userInfo.id}/` }))
          sessionStorage.setItem('logoPromptSkipped', '1')
        }}
      />
    </Box>
  )
}

export default Layout
